export default __webpack_public_path__ + "static/media/Abhishek.031088bc.jpeg";